export const formatMoney = (value: any) => {
    if (!value) {
        return null;
    }
    if (typeof value === 'number') {
        value = value.toFixed(2).toString();
    }

    value = value.replace(/\D/g, '');
    value = (parseFloat(value) / 100).toFixed(2);
    return isNaN(value) ? null : value.replace('.', ',').replace(/\d(?=(\d{3})+,)/g, '$&.');
};